//ErrorReason
export enum ErrorReason {
  ClientCodeNotExist = 1,
  FileCorrupted = 2,
  InvalidFileFormat = 3,
  UserNotFound = 4,
}
